import React, { memo as Memo } from 'react'
import { withDataContext, withUIContext } from 'context'

//* Component
import { Page } from 'components/common'
import { ImprintPage } from 'components/pages'

const Imprint = Memo(({ pages, selectedLang, pageParams, ...props }) => {
	const imprintsFakeData = {
		title: 'Imprints',

		firstSection: [
			{
				title: 'Responsible according to § 5 Telemedia Act (TMG)',

				compName: 'WeProfit GmbH',
				compAddress: 'Platz der Einheit 2, 60327 Frankfurt am Main',
				compMobile: 'Mobile: +49 (0) 174/204 8888',
				compEmail: 'Email: contact@weprofit.global',
				compWeb: 'Web: www.weprofit.global',
				compRegCourt: 'Register court: District court Frankfurt am Main',
				compHRBNum: 'HRB number: 112834 VAT ID: DE337510412',
				compAuthorized: 'Authorized representative: Arsen Abrahamyan',
			},
		],

		secondSection: [
			{
				title: 'Responsible for editorial content according to § 55 paragraph 2 of the Interstate Broadcasting Treaty',

				compAuthorized: 'Arsen Abrahamyan',
				compName: 'WeProfit GmbH',
				compAddress: 'Platz der Einheit 2, 60327 Frankfurt am Main',
				compMobile: 'Mobile: +49 (0) 174/204 8888',
			},
		],

		lastSection: [
			{
				title: 'Notice according to § 36 VSBG',
				desc: 'The European Commission provides a platform for online dispute resolution (OS), which you can find here http://ec.europa.eu/consumers/odr/.We are neither obliged nor willing to participate in a dispute settlement procedure before a consumer arbitration board.Photo credits / rights holders',
			},
		],
	}

	return (
		<Page className='imprint'>
			<ImprintPage imprintsFakeData={imprintsFakeData} />
		</Page>
	)
})

export default withUIContext(withDataContext(Imprint, ['pages']))
